import { h, Host } from "@stencil/core";
import { logger } from "../../utils/console";
export class NotificationBell {
    constructor() {
        this.counter = 0;
    }
    nativeElement;
    componentWillLoad() {
        if (!this.nativeElement.ariaLabel) {
            logger.warn("Accessibility error: 'aria-label' property is required for screen reader identification.", "warn");
        }
    }
    render() {
        return (h(Host, { key: '45a90384d473b1bfb2ebdf1424a994c597576f61', role: "status" }, h("div", { key: 'bf41287c650550d6211ad9de92c4ab85343c2f54', id: "content" }, h("ux-icon", { key: '2b35c7a62475724b047dae64f9cd0e828631e955', id: "icon", name: "bell" }), this.counter > 0 && (h("div", { key: '5e810a3cb3b48dc28823a7f87984c49069c2faea', id: "badge" }, h("ux-badge", { key: 'c37cb0cf1e802513bbe17117d0cbc7ceb005b29e' }, this.counter > 99 ? "99+" : this.counter))))));
    }
    static get is() { return "ux-notification-bell"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["notification-bell.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["notification-bell.css"]
        };
    }
    static get properties() {
        return {
            "counter": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Counter to display current notification number"
                },
                "attribute": "counter",
                "reflect": false,
                "defaultValue": "0"
            }
        };
    }
    static get elementRef() { return "nativeElement"; }
}
//# sourceMappingURL=notification-bell.js.map
